import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForbiddenComponent } from './forbidden.component';



@NgModule({
    imports: [
        CommonModule,
        ForbiddenComponent
    ],
    exports: [ForbiddenComponent]
})
export class ForbiddenModule { }
